import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import CompProfile from "../components/Frontend/BenchmarkDetails/CompProfile";
import { CompetitorProvider } from "../context/CompetitorContext";

export const compProfilesRoute = (
  // <Route path="/comp_profile/:clientId" element={<MainLayout />}>
  //   <Route index element={<CompProfile />} />
  // </Route>
  <Route
    path="/comp_profile/:clientName/:competitorName"
    element={<MainLayout />}
  >
    <Route
      index
      element={
        <CompetitorProvider>
          <CompProfile />
        </CompetitorProvider>
      }
    />
  </Route>
);
